import { render, staticRenderFns } from "./ProductMap.vue?vue&type=template&id=89c6e386&scoped=true&"
import script from "./ProductMap.vue?vue&type=script&lang=js&"
export * from "./ProductMap.vue?vue&type=script&lang=js&"
import style0 from "./ProductMap.vue?vue&type=style&index=0&id=89c6e386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c6e386",
  null
  
)

export default component.exports